import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * A custom element that shows a "backorder / ships when available" notice on the
 * product page. It re-renders itself from freshly server-rendered HTML whenever the
 * shopper switches variant, mirroring the theme's product-inventory pattern, so the
 * notice always matches the selected variant's stock state.
 */
class BackorderNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  /**
   * Updates the notice from the variant update payload.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateNotice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNotice = event.detail.data.html.querySelector('backorder-notice[data-context="product"]');

    if (!newNotice) return;

    morph(this, newNotice, { childrenOnly: true });
  };
}

if (!customElements.get('backorder-notice')) {
  customElements.define('backorder-notice', BackorderNotice);
}
